import { COMMISSION_ROUTE_NAME } from '@/libs/route-name';
import type { RouteRecordRaw } from 'vue-router';

export const commissionCategoryRoute = (): RouteRecordRaw => ({
  path: 'commission-categories',
  name: COMMISSION_ROUTE_NAME.COMMISSION_CATEGORY_LIST,
  component: () => import('@/pages/manage/commission/index.vue'),
});

export const addCommissionCategoryRoute = (): RouteRecordRaw => ({
  path: 'commission-category/add',
  name: COMMISSION_ROUTE_NAME.ADD_COMMISSION_CATEGORY,
  component: () => import('@/pages/manage/commission/add.vue'),
});

export const editCommissionCategoryRoute = (): RouteRecordRaw => ({
  path: 'commission-category/edit/:id',
  name: COMMISSION_ROUTE_NAME.EDIT_COMMISSION_CATEGORY,
  component: () => import('@/pages/manage/commission/edit.vue'),
});

